import { render, staticRenderFns } from "./reviewList.vue?vue&type=template&id=386b3b13&scoped=true"
import script from "./reviewList.vue?vue&type=script&lang=js"
export * from "./reviewList.vue?vue&type=script&lang=js"
import style0 from "./reviewList.vue?vue&type=style&index=0&id=386b3b13&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b3b13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('386b3b13')) {
      api.createRecord('386b3b13', component.options)
    } else {
      api.reload('386b3b13', component.options)
    }
    module.hot.accept("./reviewList.vue?vue&type=template&id=386b3b13&scoped=true", function () {
      api.rerender('386b3b13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/redBook/component/reviewList.vue"
export default component.exports